import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ItemStatus } from "@focus/focusUI";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError, of } from "rxjs";
import { createAsyncReducers } from "./helpers";

const baseURL = "/versioning-info/api/v1";

export type ReleaseNotesRequestKey = "getReleaseNotes";

type RequestState = {
  status: ItemStatus;
  error: string | null;
};

type RequestsMap = Record<ReleaseNotesRequestKey, RequestState>;

type ReleaseNotesPayload = {
  releaseNotes: any[];
};

type ReleaseNotesState = ReleaseNotesPayload & {
  requests: RequestsMap;
};

const initialState: ReleaseNotesState = {
  releaseNotes: [],
  requests: {
    getReleaseNotes: { status: ItemStatus.READY, error: null },
  },
};

const getReleaseNotesAsync = createAsyncReducers<
  ReleaseNotesState,
  ReleaseNotesRequestKey,
  any[]
>("getReleaseNotes", (state, action) => {
  state.releaseNotes = action.payload;
});

const ReleaseNotesSlice = createSlice({
  name: "release-notes",
  initialState,
  reducers: {
    getReleaseNotesRequest: getReleaseNotesAsync.request,
    getReleaseNotesSuccess: getReleaseNotesAsync.success,
    getReleaseNotesFailure: getReleaseNotesAsync.failure,
  },
});

export const {
  getReleaseNotesRequest,
  getReleaseNotesSuccess,
  getReleaseNotesFailure,
} = ReleaseNotesSlice.actions;

const getReleaseNotesEpic = (action, _state, { ajax }) => {
  return action.pipe(
    ofType(getReleaseNotesRequest.type),
    mergeMap(() =>
      ajax.getJSON(`${baseURL}/release-notes`).pipe(
        map((response: any) => getReleaseNotesSuccess(response)),
        catchError((error) => {
          return of(
            getReleaseNotesFailure(error.message || "Error fetching plot data"),
          );
        }),
      ),
    ),
  );
};

export default {
  actions: ReleaseNotesSlice.actions,
  reducer: ReleaseNotesSlice.reducer,
  middleware: [getReleaseNotesEpic],
  selectors: ReleaseNotesSlice.selectors,
};
